<template>
  <ErrorMessage
    class="text-md font-bold text-[--feedback-alert-darker]"
    as="p"
    :name="name"
    :data-testid="`form-error-${name}`"
  />
</template>
<script setup lang="ts">
import { ErrorMessage } from "vee-validate";

type PropTypes = {
  name: string;
};
defineProps<PropTypes>();
</script>
